import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { getInstalls, setCurrentInstall } from '../../actions/customerPortal';
import { storeWithExpiration } from '../../utils/common';

export class CustomerProspecting extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    getInstallsAction: PropTypes.func.isRequired,
    installations: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    setCurrentInstallAction: PropTypes.func.isRequired,
  };

  static defaultProps = {
    data: null,
  };

  componentWillMount = () => {
    const { data, getInstallsAction, installations, params, setCurrentInstallAction } = this.props;
    const { instanceId } = params;
    let installObj = null;
    if (installations) {
      installObj = installations
        .valueSeq()
        .find(
          install => install && install.installation.get('id').toString() === instanceId.toString()
        );
    }
    if (installObj && data && data.installation && data.installation.id !== instanceId) {
      setCurrentInstallAction(installObj);
    } else {
      const token = storeWithExpiration.get('token');
      getInstallsAction(token, instanceId);
    }
  };

  componentDidMount = () => {
    if (window.DR_CSV_DOWNLOAD_ENABLED) {
      window.frames['prospecting-container'].window.DR_CSV_DOWNLOAD_ENABLED = window.DR_CSV_DOWNLOAD_ENABLED;
    }
    return null;
  }

  componentDidUpdate = () => {
    if (window.DR_CSV_DOWNLOAD_ENABLED) {
      window.frames['prospecting-container'].window.DR_CSV_DOWNLOAD_ENABLED = window.DR_CSV_DOWNLOAD_ENABLED;
    }
    return null;
  }

  render() {
    const { data, params } = this.props;

    // Only display if we have the install data
    if (!data) {
      return null;
    }

    // We allow tagFilters to be either passed as a single filter or an array of them.
    const installation = data.get('installation');
    const platformCode = data.get('platformCode').toString();
    const instanceName = installation.get('description');
    const installKey = installation.get('installKey');
    const tagFilter = params.tagFilter ? JSON.parse(params.tagFilter) : null;
    const encodedTagFilter = tagFilter
      ? encodeURIComponent(JSON.stringify(Array.isArray(tagFilter) ? tagFilter : [tagFilter]))
      : encodeURIComponent('[]');
    const baseURL = tagFilter ? '../../search_frame/' : '../search_frame/';
    const iframeURL = `${baseURL}${platformCode}/${installKey}/${encodedTagFilter}`;
    const primaryTagFilter = Array.isArray(tagFilter) ? tagFilter[0] : tagFilter;

    const customConfiguration = installation.get('customConfiguration');

    if(customConfiguration && customConfiguration.csvDownloadEnabled) {
        window.DR_CSV_DOWNLOAD_ENABLED = customConfiguration.csvDownloadEnabled || undefined;
    }

    return (
      <div className="modal-wrap">
        <div className="row row-top">
          <div className="col-xs-12">
            <h1>
              <Link to="/home">
                <i className="fa fa-angle-left" /> {instanceName}
              </Link>
            </h1>
            {primaryTagFilter ? (
              <h2 className="sub-header">
                <span className="less-important">Prospecting For</span>{' '}
                {!primaryTagFilter.tagDescription
                  ? primaryTagFilter.tagValue
                  : primaryTagFilter.tagDescription}
              </h2>
            ) : null}
          </div>
        </div>
        <div>
          <iframe name="prospecting-container" title="prospecting" src={iframeURL} className="container iframe-full-width" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authentication, dialog, customerPortalData, account, user } = state;
  const installations = customerPortalData.get('installations');
  const data = customerPortalData.get('currentInstall');
  return {
    account,
    authentication,
    data,
    dialog,
    installations,
    user,
  };
}

export default connect(
  mapStateToProps,
  {
    getInstallsAction: getInstalls,
    setCurrentInstallAction: setCurrentInstall,
  }
)(CustomerProspecting);
